import { STATE } from '../constants/stateClasses';
import { breakpoints } from '../utils/breakpoints';
import toggleClass from '../utils/toggleClass';
import { scroll } from './locomotive';

const handleContactRepeater = () => {
  const selectors = {
    btn: '.js-contact-repeater-btn',
    section: '.js-contact-repeater-section',
    navList: '.js-contact-repeater-list',
    header: '.js-header',
  };

  const sections = [...document.querySelectorAll(selectors.section)];

  if (sections.length === 0) return;

  const header = document.querySelector(selectors.header);
  const navList = document.querySelector(selectors.navList);
  const btns = [...navList.querySelectorAll(selectors.btn)];

  let activeBtn = btns.find((btn) => btn.classList.contains(STATE.active));

  const handleBtnClick = (e) => {
    const { currentTarget } = e;
    const { id } = currentTarget.dataset;

    const chosenSection = sections.find((section) => section.dataset.id === id);

    // Prevent from the header's overflow
    const scrollOptions = {
      offset:
        window.innerWidth < breakpoints.tablet
          ? -(header.clientHeight + navList.clientHeight)
          : -header.clientHeight,
    };

    scroll.scrollTo(chosenSection, scrollOptions);
  };

  const handleScrollCall = (param, direction) => {
    if (direction === 'exit') return;

    const currentActiveBtn = btns.find((btn) => btn.dataset.id === param);

    toggleClass(activeBtn, { className: STATE.active, force: false });
    toggleClass(currentActiveBtn, { className: STATE.active, force: true });

    activeBtn = currentActiveBtn;
  };

  btns.forEach((btn) => {
    btn.addEventListener('click', handleBtnClick);
  });

  scroll.on('call', handleScrollCall);
};
export default handleContactRepeater;
